import { ConfigProvider } from "antd";
import "../../styles/admin-ds.css";

// antd shape tokens matching the admin design system (styles/admin-ds.css).
// Colours are left at the app defaults.
const DS_THEME = {
  token: {
    borderRadius: 5,
    fontSize: 13,
  },
};

const DsTheme = ({ children }) => (
  <ConfigProvider theme={DS_THEME}>{children}</ConfigProvider>
);

export default DsTheme;
